import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerRegistrationComponent } from './customer-registration.component';
import { RegistrationRoutingModule } from './registration-routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RegistrationFormComponent } from './registration-form/registration-form.component';
import { OtpVerifyComponent } from './otp-verify/otp-verify.component';
import { CreatePasswordComponent } from './create-password/create-password.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import {NgxIntlTelInputModule} from 'ngx-intl-tel-input';
import { HttpClientModule } from '@angular/common/http';
import { InterestDialogComponent } from './interest-dialog/interest-dialog.component';
// import { SharedModule } from 'projects/common-resource';
import { IndustryDialogComponent } from './industry-dialog/industry-dialog.component';
import { ZipcodeConfirmationDialogComponent } from './zipcode-confirmation-dialog/zipcode-confirmation-dialog.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { PreRegisterComponent } from './pre-register/pre-register.component';
@NgModule({
  declarations: [
    CustomerRegistrationComponent,
    RegistrationFormComponent,
    OtpVerifyComponent,
    CreatePasswordComponent,
    WelcomeComponent,
    TermsAndConditionsComponent,
    InterestDialogComponent,
    IndustryDialogComponent,
    ZipcodeConfirmationDialogComponent,
    PreRegisterComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    RegistrationRoutingModule,
    ReactiveFormsModule,
    NgOtpInputModule,
    NgxIntlTelInputModule,
    FormsModule,
    HttpClientModule,
    //SharedModule
  ]
})
export class RegistrationModuleModule { }
